import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      width: '100%',

      [mediaQuery(1365)]: {
        position: 'relative',
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s0, Spacings.s24],
      },
    },
    controls: {
      position: 'absolute',
      top: '50%',
      left: Spacings.s0,
      width: '100%',
      transform: 'translateY(-50%)',
      zIndex: 1,

      [mediaQuery(1023)]: {
        visibility: 'hidden',
      },
    },
    container: {
      position: 'relative',
      width: '100%',
      maxWidth: 1088,
      margin: [Spacings.s0, 'auto'],

      [mediaQuery(1365)]: {
        position: 'initial',
        maxWidth: 934,
      },
    },
    imagesOuterWrapper: {
      width: '100%',
      maxWidth: 1076,
      margin: [Spacings.s0, 'auto'],
      overflow: 'scroll',
      scrollBehavior: 'smooth',

      // IE and Edge
      '-ms-overflow-style': 'none',
      // Mozilla
      scrollbarWidth: 'none',
      // Chrome, Safari
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    imagesWrapper: {
      display: 'flex',
      flexWrap: 'nowrap',
      width: 'fit-content',
    },
    imageHolder: {
      display: 'block',
      height: '100%',
      width: 216,

      '&:not(:last-child)': {
        marginRight: Spacings.s24,
      },
    },
    image: {
      borderRadius: CornerRadius.r16,
    },
  }),
  {
    name: 'header-banner-with-dynamic-scroller',
  },
);
export default useStyles;
